import router from "@/router";
import {AxiosResponse} from "axios";
import {RouteLocationRaw} from "vue-router";
import {ROUTE} from "@/content/pages/routes";

const ROUTE_FOR_STATUS: { [status: number]: RouteLocationRaw } = {
  404: ROUTE.NotFound({}),
  403: ROUTE.NotAllowed({})
}

/**
 * Unwraps the API envelope and, on failure, sends the user to a page that explains what happened.
 *
 * The status is read from the HTTP response first and only then from the body: a request that never
 * reached the backend (network error, CORS, aborted) has no body at all, and reading `code` from it
 * used to throw a TypeError that replaced the real error.
 */
const handleResponse = async (request: Promise<AxiosResponse>) => {
  try {
    const response = await request
    return response.data.item || response.data.items
  } catch (error: any) {
    const status: number | undefined = error?.response?.data?.code ?? error?.response?.status
    await router.push((status !== undefined && ROUTE_FOR_STATUS[status]) || ROUTE.Error({}))

    throw error;
  }
}


export default handleResponse
